import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

const optionalOdooId = z.number().int().positive().nullable().optional();

export const odooSettings = defineIntegrationSettings({
  fields: {
    url: z.string().trim().min(1, "Odoo URL is required"),
    database: z.string().trim().min(1, "Database is required"),
    username: z.string().trim().min(1, "Username is required"),
    version: z.union([z.literal(16), z.literal(17)]),
    autoPostCreditNotes: z.boolean(),
    creditNoteJournalId: optionalOdooId,
    partialReturnCorrectionConceptId: optionalOdooId,
  },
  secrets: { apiKey: z.string().trim().min(1, "API key is required") },
  connectOnly: {},
  computed: {},
});
